/**
 * Created by spepa on 24.10.2022
 */

const AchievementDonorIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.landmarkdonor_icon_json,
        resetOnFreeFocus: true
    });

    this.resetState();
};

AchievementDonorIcon.prototype = Object.create(SideBarIcon.prototype);
AchievementDonorIcon.prototype.constructor = AchievementDonorIcon;

AchievementDonorIcon.prototype.resetState = function () {
    this.available = false;

    if (!cleverapps.environment.isMainScene()) {
        return;
    }

    const config = this.findWithProgress();
    if (config) {
        this.available = true;
        this.setAttention(cleverapps.achievements.getPendingProgress(config));
        this.setLeftTime(cleverapps.achievements.getTimeLeft(config));
    }
};

AchievementDonorIcon.prototype.findWithProgress = function () {
    const configs = cleverapps.achievements.listByActiveExpeditions() || [];

    for (let i = 0; i < configs.length; ++i) {
        const config = configs[i];

        if (cleverapps.achievements.getPendingProgress(config)) {
            return config;
        }
    }

    return configs[0];
};

AchievementDonorIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "AchievementDonorIconClicked",
        action: function (f) {
            new DonorProgressWindow(this.findWithProgress());
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });
};

AchievementDonorIcon.prototype.getForce = function () {
    return Achievements.getForce(cleverapps.meta.selectedLocationId());
};
